import { render, staticRenderFns } from "./student-evaluation.vue?vue&type=template&id=d6bdf9ac&scoped=true&"
import script from "./student-evaluation.vue?vue&type=script&lang=js&"
export * from "./student-evaluation.vue?vue&type=script&lang=js&"
import style0 from "./student-evaluation.vue?vue&type=style&index=0&id=d6bdf9ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bdf9ac",
  null
  
)

export default component.exports